export default __webpack_public_path__ + "static/websiteTopBanner-0b003f77a6cd819b8af9c6ae36def158.webp";